import feature1 from '../assets/feature1.webp';
import feature2 from '../assets/feature2.webp';
import feature3 from '../assets/feature3.webp';

const features = [
  {
    img: feature1,
    title: 'Zero Fees',
    subtitle: 'Send for free',
    description: 'Send crypto for free when the recipient accepts payment in the same currency. Keep more of your money.',
    accent: 'from-emerald-500 to-teal-500',
    bg: 'bg-emerald-500/5 border-emerald-500/20',
    tag: 'Most Popular',
  },
  {
    img: feature2,
    title: 'Military-Grade Security',
    subtitle: 'Your assets, protected',
    description: 'We comply with strict legal requirements preventing money laundering, fraud, and all illegal activity.',
    accent: 'from-violet-500 to-indigo-500',
    bg: 'bg-violet-500/5 border-violet-500/20',
    tag: 'Fully Compliant',
  },
  {
    img: feature3,
    title: 'Instant Transfers',
    subtitle: 'Seconds, not days',
    description: 'Complete cross-border payments in seconds. Intuitive design makes it perfect for beginners and pros alike.',
    accent: 'from-orange-500 to-amber-500',
    bg: 'bg-orange-500/5 border-orange-500/20',
    tag: 'Lightning Fast',
  },
];

function Features() {
  return (
    <div className="container mx-auto px-4"> {/* Outer container */}
      <section className="bg-[#0a0a1a] py-16 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-20">
            <span className="inline-block text-violet-400 text-sm font-bold tracking-widest uppercase mb-4">
              Why Ellipticline
            </span>
            <h2 className="text-4xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Built different.<br />
              <span className="bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent">
                Designed better.
              </span>
            </h2>
            <p className="text-gray-500 text-lg max-w-xl mx-auto">
              Everything you need for seamless crypto and fiat management, in one elegant platform.
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div
                key={i}
                className={`relative group border ${f.bg} rounded-3xl p-8 backdrop-blur-sm hover:scale-[1.02] transition-all duration-300 cursor-pointer flex flex-col justify-between`}
              >
                <div>
                  {/* Tag */}
                  <div
                    className={`inline-block text-xs font-bold px-3 py-1 rounded-full bg-gradient-to-r ${f.accent} text-white mb-6`}
                  >
                    {f.tag}
                  </div>

                  {/* Image */}
                  <div className="mb-6">
                    <img src={f.img} alt={f.title} className="w-20 h-20 object-contain" />
                  </div>

                  {/* Subtitle */}
                  <p
                    className={`text-sm font-semibold bg-gradient-to-r ${f.accent} bg-clip-text text-transparent mb-2`}
                  >
                    {f.subtitle}
                  </p>

                  {/* Title */}
                  <h3 className="text-2xl font-black text-white mb-3">{f.title}</h3>

                  {/* Description */}
                  <p className="text-gray-500 text-sm leading-relaxed">{f.description}</p>
                </div>

                {/* Arrow */}
                <div
                  className={`mt-6 flex items-center gap-2 text-sm font-semibold bg-gradient-to-r ${f.accent} bg-clip-text text-transparent group-hover:gap-3 transition-all`}
                >
                  <span>Learn more</span>
                  <span>→</span>
                </div>

                {/* Hover glow */}
                <div
                  className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${f.accent} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}
                ></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Features;